import { getCert, placeOrder } from '../lib/api.js';
import { renderNotFound } from './notFound.js';

const FIELDS = ['name', 'address', 'city', 'postalCode', 'country'];

export async function renderCheckout(root, { certId }) {
  let cert;
  try { cert = await getCert(certId); }
  catch { return renderNotFound(root); }

  root.innerHTML = `
    <div class="checkout-page">
      <header class="checkout-header"><a href="/c/${cert.slug}-${cert.id}">← Back to certificate</a></header>
      <main class="checkout-main">
        <div class="checkout-section-label">YOUR ORDER</div>
        <div class="order-row">
          <div class="order-thumb"></div>
          <div class="order-info">
            <div class="order-title">Framed Certificate of Gayness</div>
            <div class="order-meta">A4 · Walnut frame · Glass</div>
          </div>
          <div class="order-price">$0.00</div>
        </div>
        <form class="order-form" data-test="order-form">
          <div class="checkout-section-label">SHIPPING TO</div>
          <input class="forensic-input" placeholder="Full name" data-test="field-name" />
          <input class="forensic-input" placeholder="Address" data-test="field-address" />
          <div class="checkout-row">
            <input class="forensic-input" placeholder="City" data-test="field-city" />
            <input class="forensic-input" placeholder="Postal code" data-test="field-postalCode" />
          </div>
          <input class="forensic-input" placeholder="Country" data-test="field-country" />
          <button class="btn btn-rainbow" type="submit" data-test="place-order" disabled>Place Order — $0.00</button>
          <div class="checkout-disclaimer">No actual frame will be shipped. Yet.</div>
        </form>
      </main>
    </div>
  `;
  const inputs = FIELDS.map((f) => root.querySelector(`[data-test=field-${f}]`));
  const btn = root.querySelector('[data-test=place-order]');
  const update = () => { btn.disabled = inputs.some((i) => !i.value.trim()); };
  inputs.forEach((i) => i.addEventListener('input', update));

  root.querySelector('[data-test=order-form]').addEventListener('submit', async (e) => {
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true; btn.textContent = 'Processing $0.00…';
    const payload = { certId };
    for (const f of FIELDS) payload[f] = root.querySelector(`[data-test=field-${f}]`).value.trim();
    try {
      await placeOrder(payload);
      root.innerHTML = `
        <div class="checkout-page" style="text-align:center;padding:80px 24px">
          <div style="font-size:64px;margin-bottom:16px">📦</div>
          <h1 style="font-size:24px">Order received.</h1>
          <p style="color:#666;margin-top:12px">No frame will arrive. The bit is the reward.</p>
          <a class="btn btn-rainbow" href="/" style="display:inline-block;margin-top:24px;padding:14px 24px;text-decoration:none">Certify someone else</a>
        </div>
      `;
    } catch {
      btn.disabled = false; btn.textContent = 'Place Order — $0.00';
    }
  });
}
